export default __webpack_public_path__ + "static/gac-7fb1d3c9227478e3b3906ce8978e0e1d.png";